var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgProjectdashboard = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "12px",
    viewBox: "0 0 14 12",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "globe")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0.-Menu-General-",
    transform: "translate(-33.000000, -102.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.-Project-Dashboard",
    transform: "translate(33.000000, 95.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 0.000434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Hardware-/-desktop_windows",
    transform: "translate(0.000000, 5.997397)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 13.8974164 0 13.8974164 13.8974164 0 13.8974164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1602394,1.15811803 L1.73717705,1.15811803 C1.10021213,1.15811803 0.579059017,1.67927115 0.579059017,2.31623607 L0.579059017,9.26494427 C0.579059017,9.90190919 1.10021213,10.4230623 1.73717705,10.4230623 L5.79059017,10.4230623 L5.79059017,11.5811803 L4.63247214,11.5811803 L4.63247214,12.7392984 L9.26494427,12.7392984 L9.26494427,11.5811803 L8.10682624,11.5811803 L8.10682624,10.4230623 L12.1602394,10.4230623 C12.7972043,10.4230623 13.3183574,9.90190919 13.3183574,9.26494427 L13.3183574,2.31623607 C13.3183574,1.67927115 12.7972043,1.15811803 12.1602394,1.15811803 Z M12.1602394,9.26494427 L1.73717705,9.26494427 L1.73717705,2.31623607 L12.1602394,2.31623607 L12.1602394,9.26494427 Z",
    id: "\\uD83D\\uDD39-Icon-Color",
    fill: "#FFFFFF"
  }))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgProjectdashboard, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/projectdashboard.1dfbb80c.svg";
export { ForwardRef as ReactComponent };